export default __webpack_public_path__ + "static/media/fem_3.5764cc43.png";